import React from 'react';

type LogFilter = 'all' | 'combat' | 'movement' | 'important';

interface BattleLogPanelProps {
  entries: string[];
  filter: LogFilter;
  onFilterChange: (filter: LogFilter) => void;
  logContentRef: React.RefObject<HTMLDivElement | null>;
}

function getFilteredEntries(entries: string[], filter: LogFilter): string[] {
  if (filter === 'all') return entries;

  return entries.filter(entry => {
    const message = entry.toLowerCase();
    switch (filter) {
      case 'combat':
        return message.includes('⚔️') || message.includes('💥') || message.includes('🗡️') ||
               message.includes('🔥') || message.includes('✨') || message.includes('⚡') ||
               message.includes('🧊') || message.includes('💚') || message.includes('💞') ||
               message.includes('strikes') || message.includes('damage') || message.includes('defeated') ||
               message.includes('casts') || message.includes('hurls') || message.includes('launches');
      case 'movement':
        return message.includes('🏃') || message.includes('👣') || message.includes('🔄') ||
               message.includes('charges') || message.includes('advances') || message.includes('repositions');
      case 'important':
        return message.includes('💀 defeated') || message.includes('🏆') || message.includes('💎') ||
               message.includes('📜') || message.includes('📈') || message.includes('🎯') ||
               message.includes('victory') || message.includes('defeat') || message.includes('level up') ||
               message.includes('loot') || message.includes('recipe') || message.includes('turn');
      default:
        return true;
    }
  });
}

const BattleLogPanel: React.FC<BattleLogPanelProps> = ({ entries, filter, onFilterChange, logContentRef }) => {
  const filtered = getFilteredEntries(entries, filter);

  return (
    <div className="battle-log-bottom">
      <div className="battle-log-header">
        <h3>Battle Log</h3>
        <div className="battle-log-filters">
          <button className={`filter-btn ${filter === 'all' ? 'active' : ''}`} onClick={() => onFilterChange('all')}>All</button>
          <button className={`filter-btn ${filter === 'combat' ? 'active' : ''}`} onClick={() => onFilterChange('combat')}>Combat</button>
          <button className={`filter-btn ${filter === 'movement' ? 'active' : ''}`} onClick={() => onFilterChange('movement')}>Movement</button>
          <button className={`filter-btn ${filter === 'important' ? 'active' : ''}`} onClick={() => onFilterChange('important')}>Important</button>
        </div>
      </div>
      <div className="log-content" ref={logContentRef}>
        {filtered.map((entry, index) => (
          <div key={index} className="log-entry">
            {entry}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BattleLogPanel;
